/** 🌍 GLOBAL STANDART KOD (TÜM PROJELER İÇİN GEÇERLİDİR) */
import { useState, useRef, useEffect } from 'react';
import { WORKSPACE_SIGN_OUT_EVENT, WORKSPACE_EPOCH_KEY, parseWorkspaceNotice } from './workspace-notice.contract';
import './SecurityKeysPanel.css';
import { Alert } from './Alert';
import { twoFactorLabels } from './two-factor-labels';
import { securityKeysLabels } from './security-keys-labels';
import { performSecurityKeyCeremony, securityKeyData } from './security-keys-client';
export function TwoFactorLogin({ locale, request, onComplete, onBack }: {
 locale: string; request: (action: string, body: unknown, signal?: AbortSignal) => Promise<unknown>;
 onComplete: (requiresWorkspaceSelection: boolean) => void | Promise<void>; onBack: () => void;
}) {
 const copy = twoFactorLabels(locale), keys = securityKeysLabels(locale);
 const [busy, setBusy] = useState(false), [error, setError] = useState(''), [recovery, setRecovery] = useState(false), [code, setCode] = useState('');
 const active = useRef(false);
 const lifetime = useRef(new AbortController()), back = useRef(onBack); back.current = onBack;
 useEffect(() => {
  const controller = new AbortController(); lifetime.current = controller;
  const cancel = () => { controller.abort(); back.current(); };
  const storage = (event: StorageEvent) => { if (event.key === WORKSPACE_EPOCH_KEY && parseWorkspaceNotice(event.newValue)?.phase === 'signed-out') cancel(); };
  window.addEventListener(WORKSPACE_SIGN_OUT_EVENT,cancel); window.addEventListener('storage',storage);
  return () => { controller.abort(); window.removeEventListener(WORKSPACE_SIGN_OUT_EVENT,cancel); window.removeEventListener('storage',storage); };
 }, []);
 async function verify() {
  if (active.current) return; active.current = true; setBusy(true); setError('');
  const signal = lifetime.current.signal;
  try {
   let result;
   if (recovery) { result = await request('recovery', {code}, signal); signal.throwIfAborted(); setCode(''); }
   else {
    const challenge = securityKeyData<{challengeId:string; options:Record<string,unknown>}>(await request('options', {}, signal));
    signal.throwIfAborted();
    const response = await performSecurityKeyCeremony(challenge.options, false, signal);
    signal.throwIfAborted();
    result = await request('verify', {challengeId:challenge.challengeId, response}, signal);
   }
   signal.throwIfAborted();
   const data = securityKeyData<{requiresWorkspaceSelection:boolean}>(result);
   await onComplete(data.requiresWorkspaceSelection === true);
  } catch (reason) {
   if (!signal.aborted) setError(reason instanceof DOMException ? keys.cancelled : reason instanceof Error ? reason.message : keys.failed);
  } finally { active.current = false; if (!signal.aborted) setBusy(false); }
 }
 return <section aria-label={copy.title} className="qp-two-factor-login">
  <h2>{copy.title}</h2><p>{copy.help}</p>
  <Alert type="error" message={error} placement="banner" onDismiss={() => setError('')} />
  {recovery && <label>{copy.recoveryCode}<input autoComplete="off" spellCheck={false} value={code} maxLength={48} onChange={e => setCode(e.target.value)} disabled={busy} /></label>}
  <button type="button" className="btn-primary" disabled={busy || recovery && code.trim().length < 32} onClick={() => void verify()}>{busy ? keys.loading : recovery ? keys.continue : keys.verifyKey}</button>
  <button type="button" className="btn-secondary" disabled={busy} onClick={() => { setRecovery(!recovery); setCode(''); setError(''); }}>{recovery ? keys.verifyKey : copy.useRecovery}</button>
  <button type="button" className="btn-secondary" disabled={busy} onClick={onBack}>{copy.back}</button>
 </section>;
}
